// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1qzJj","buttons":"RemoveExpirationActionButtons_buttons__1xiRo"};